import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SFSOptions } from '../data-table';
import { OrganizationService } from './organization.service';
import { Pageable, Organization } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PartnerOrganizationService extends OrganizationService {
  protected override defaultSFSOptions: Partial<SFSOptions> = {
    sortColumn: 'name',
    sortOrder: 'asc',
  };

  protected override get apiEndpoint(): string {
    return '/organization';
  }

  override list(options: Partial<SFSOptions> = {}): Observable<Pageable<Organization>> {
    const params = this.getParams(options);
    return this.http.get<Pageable<Organization>>(this.baseUrl + this.apiEndpoint + '/partner', {
      params,
    }).pipe(map((page) => {
      page.content = page.content.map((item) => this.loadedDataTransform(item));
      return page;
    }));
  }

  override get(id: string): Observable<Organization> {
    return this.http.get<Organization>(`${this.baseUrl + this.apiEndpoint}/partner/${id}`).pipe(map((item) => this.loadedDataTransform(item)));
  }

  override update(object: Organization): Observable<Organization> {
    return this.http.put<Organization>(
      `${this.baseUrl + this.apiEndpoint}/partner/${object.id}`,
      object,
      { headers: this.getHeades() },
    ).pipe(map((item) => this.loadedDataTransform(item)));
  }
}
